import { isNumber } from "lodash";

import type { Order } from "../../../../../../../services";
import type { DateFns } from "../../../../../../../utils/DateFns";

const cellProcessing = (item?: Order.Model, dateFns?: DateFns): string => {
	if (!item?.id || !dateFns) return "";

	const waitingTimeMilliseconds = isNumber(
		item?.additionalFields?.waitingTimeMilliseconds,
	)
		? item.additionalFields.waitingTimeMilliseconds
		: 0;

	const waitingClient = isNumber(item?.downtimes?.waitingClient)
		? item.downtimes.waitingClient
		: 0;

	const value = Math.max(waitingClient + waitingTimeMilliseconds, 0);
	if (!value) return "";
	return dateFns.formatTime2(value, "HH:mm:ss", { timezone: "UTC" });
};

export default cellProcessing;
